export default [
  {
    path: "/login",
    component: () => import("./pages/Login"),
  },
  {
    path: "/reset-password",
    component: () => import("./pages/ResetPassword"),
  },
  {
    path: "/set-password/:token",
    component: () => import("./pages/SetPassword"),
  },
  {
    path: "/change-temp-password",
    component: () => import("./pages/ChangeTempPassword"),
  },
  {
    path: "/two-factor-auth",
    component: () => import("./pages/TwoFactorAuth"),
  },
];
